<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div class="row m-0 modal-content slider-content watermark-bg" *ngIf="showNotification === 1">

    <div class="notification-header py-2">All Notifications</div>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSlideShow()"
        style="top:-15px; z-index: 1;">
        <span aria-hidden="true" class="">&times;</span>
    </button>

    <div class="dropdown-item waves-light notificationHolder p-2" mdbWavesEffect href="#"
    *ngFor="let data of notificationData" (click)="navigateToEditviewDashboard(data)">
    <img src="{{data?.customerPhoto}}" alt="">
    <span style="white-space: normal;">{{data?.customerName}}  | {{data?.profileID}}<br/>
      <span>{{data?.actionName}}</span>
    </span>
  </div>
  <div class="col-md-3 p-0 pt-1 pb-1 load-more" style="cursor: pointer;" *ngIf="allNotificationUsers?.length >= 10 && !loadAllNotificationData" (click)="loadMoreNotificationData()">Load More</div>
</div>

<div class="row m-0 modal-content slider-content watermark-bg" *ngIf="showNotification === 2">

  <div class="notification-header py-2">Currently Logged In Users</div>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeSlideShow()"
      style="top:-15px; z-index: 1;">
      <span aria-hidden="true" class="">&times;</span>
  </button>

  <div class="dropdown-item waves-light notificationHolder p-2" mdbWavesEffect href="#"
  *ngFor="let data of allLoggedUsers" (click)="navigateToEditviewDashboard(data)">
    <img src="{{data?.CustomerPhoto}}" alt="">
    <span style="white-space: normal;">{{data?.CustomerName}}  | <span [ngStyle]="{'color':getAssignTicketColour(data)}">{{getProfileType(data)}}</span><br/>
      <!-- <span>{{data?.actionName}}</span> -->
    </span>
  </div>
  <div class="col-md-3 p-0 pt-1 pb-1 load-more" *ngIf="allLoggedUsers?.length >= 10 && !loadAllLoggedData" (click)="loadMoreLoggedUsers()">Load More</div>
</div>
